import axios from 'axios';
import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';

export class EncounterDocumentsService {
  constructor() {
    this.apiBase = API_BASE;
  }

  async getAuthHeaders() {
    const token = await getAuthToken();
    if (!token) {
      throw new Error('No authentication token available');
    }
    return { Authorization: `Bearer ${token}` };
  }

  async getEncounterDocuments(encounterId) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.get(`${this.apiBase}/clinical/encounters/${encounterId}/documents`, { headers });
      return response.data.documents || [];
    } catch (error) {
      console.error('Error fetching encounter documents:', error);
      throw new Error('Failed to fetch encounter documents');
    }
  }

  async createEncounterDocument(encounterId, documentData) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.post(`${this.apiBase}/clinical/encounters/${encounterId}/documents`, documentData, { headers });
      return response.data;
    } catch (error) {
      console.error('Error creating encounter document:', error);
      throw new Error('Failed to create encounter document');
    }
  }

  async updateEncounterDocument(documentId, updates) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.put(`${this.apiBase}/clinical/encounters/documents/${documentId}`, updates, { headers });
      return response.data;
    } catch (error) {
      console.error('Error updating encounter document:', error);
      throw new Error('Failed to update encounter document');
    }
  }

  async deleteEncounterDocument(documentId) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.delete(`${this.apiBase}/clinical/encounters/documents/${documentId}`, { headers });
      return response.data;
    } catch (error) {
      console.error('Error deleting encounter document:', error);
      throw new Error('Failed to delete encounter document');
    }
  }
}

export default EncounterDocumentsService;
